import React from "react";
import "./Main.css";

const Main = () => {
  const imgstyle = {
    height: "54px",
    margin: "15px",
    width: "250px",
  };

  return (
    <div className="jumbotron jumbotron-main big-banner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col">
            <a
              href="https://www.producthunt.com/posts/gobillion-2?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-gobillion-2"
              rel="noreferrer"
              target="_blank"
            >
              <img
                src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=307023&theme=light"
                style={imgstyle}
                alt="Gobillion - Making ecommerce social for the next 400M
                customers in India | Product Hunt"
              />
            </a>
            <div className="col-md-7 col-sm-12 py-md-5 pb-sm-0 for-786-992-main">
              <p className="head-para">
                Welcome to Gobillion.
                {/* <p className="head-para-tag">
                  We are serving customers in Guwahati & Kolkata, India.
                </p> */}
              </p>
            </div>

            {/* <div className="btn-div-one">
              <a
                href="https://play.google.com/store/apps/details?id=com.gobillion.android.commerce"
                className="btn dow-button"
                aria-label="Download Gobillion app from Google Play Store"
              >
                <span>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M19,9H15L13,7H9V9H15V11H4A2,2 0 0,0 2,13V20A2,2 0 0,0 4,22H20A2,2 0 0,0 22,20V11A2,2 0 0,0 20,9H19M15,13V18H13V13H15M11,13V18H9V13H11M7,13V18H5V13H7M19,13V18H17V13H19Z" />
                  </svg>
                </span>
                <span> Download App</span>
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Main;
